<template>
  <section
    :class="[
      'image-text',
      `image-text--${data.orientation}`,
    ]"
  >
    <div class="c-container">
      <AppPicture
        :data="{ url: data.image }"
        class="image-text__picture"
      />
      <AppTextBlock
        :data="{ content: data.alt }"
        class="image-text__content"
      />
    </div>
  </section>
</template>

<script>
import AppPicture from '@/components/AppPicture.vue';
import AppTextBlock from '@/components/AppTextBlock.vue';


export default {
  name: 'imageText',

  components: {
    AppPicture,
    AppTextBlock,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/variables';
@import '../style/mixins';

.image-text {
  .c-container {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    flex-flow: row wrap;
  }

  &__picture {
    width: 100%;
    flex: 0 0 100%;

    @include aspect-ratio(4, 2.5);

    @include mq(ipadP) {
      width: calc(70% - 120px);
      flex: 0 0 calc(70% - 120px);
    }
  }

  &__content {
    margin-top: 40px;

    @include mq(ipadP) {
      width: 30%;
      flex: 1 0 30%;
      max-width: 400px;
      margin-top: 0;
      padding-left: 80px;
      box-sizing: border-box;
    }
  }
}
</style>
